import { cn } from '@/lib/ui/utils';
import styles from './cms-account-settings-dialog.module.css';

export const cmsAccountSettingsDialogContentClassName = cn(
  'cms-theme h-[min(48rem,calc(100dvh-1rem))] w-[min(70rem,calc(100vw-1rem))] max-w-none gap-0 overflow-hidden border-[var(--cms-workspace-floating-surface-border-color)] bg-[var(--cms-workspace-surface-panel)] p-0 shadow-[var(--cms-workspace-floating-surface-shadow)] sm:h-[min(48rem,calc(100dvh-2rem))] sm:w-[min(70rem,calc(100vw-2rem))] sm:max-w-none',
  styles.dialogContent
);

export const cmsAccountSettingsDialogPositionerClassName = 'p-2 sm:p-4';

export const cmsAccountSettingsDrawerBodyClassName = cn(
  styles.dialogContent,
  styles.drawerContent
);
